export default function initAccordion() {

  const accordionItem = document.querySelectorAll(".accordion--item");

  accordionItem.forEach(function (accordion) {
    const header = accordion.querySelector(".accordion--header");

    header.addEventListener("click", function () {
      accordion.classList.toggle("active");
    });
  });
}
